import {get,post} from "@/utils/request.js"

/* 
	公共页面调用
 */
// 获取购物车数据
export function getAppCCartByUser(data){
	return post('/admin/appCCart/getAppCCartByUser',data)
}
// 删除购物车商品
export function delAppCCartByUser(data){
	return post('/admin/appCCart/delAppCCartByUser',data)
}
// 商品数量+-
export function subAndAddAppCCartByUser(data){
	return post('/admin/appCCart/subAndAddAppCCartByUser',data)
}
// 修改商品规格
export function upAppCCart(data){
	return post('/admin/appCCart/upAppCCart',data)
}
// 购物车商品规格====添加附件
export function addAppCFile(data){
	return post('/app/appCFile/addAppCFile',data)
}
// 购物车商品规格====修改附件
export function upAppCFile(data){
	return post('/app/appCFile/upAppCFile',data)
}